// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"61312278","703":"1cdf774c"}[chunkId] + ".chunk.js";
};